/**
 * テキストをクリップボードへコピーする (issue #140)。
 *
 * navigator.clipboard.writeText を優先し、 未サポート / reject (権限拒否・非セキュア
 * コンテキスト等) の場合は execCommand('copy') フォールバックへ落ちる。 両方不可なら false。
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  const clipboard = typeof navigator !== 'undefined' ? navigator.clipboard : undefined;
  if (clipboard && typeof clipboard.writeText === 'function') {
    try {
      await clipboard.writeText(text);
      return true;
    } catch {
      // writeText 拒否 → execCommand フォールバックへ
    }
  }
  return copyViaExecCommand(text);
}

/** 非表示 textarea + execCommand('copy') による旧来コピー。成否を boolean で返す。 */
function copyViaExecCommand(text: string): boolean {
  if (typeof document === 'undefined' || typeof document.execCommand !== 'function') {
    return false;
  }
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch {
    // execCommand が throw → ok は false のまま
  }
  document.body.removeChild(textarea);
  return ok;
}
